<script>
import PanelContainer from '@/launcher/components/shared/PanelContainer.vue';
import CancelDialogBoxConnected from '@/launcher/components/connected/CancelDialogBoxConnected';

export default {
  name: 'CancelDialogBox',
  components: {
    PanelContainer,
    CancelDialogBoxConnected,
  },
};
</script>

<template lang="pug">
PanelContainer.panel(id="canceldialogpanel" usage="launcher" :modal="true")
  CancelDialogBoxConnected
</template>

<style scoped>
.panel {
  width: 520px;
  flex-shrink: 0;
  margin-right: 100px;
}
</style>
